const { createAction } = require('../helpers')
const {
  GET_USER_APPOINTMENTS_LIST,
  GET_USER_APPOINTMENTS_LIST_SUCCESS,
  GET_USER_APPOINTMENTS_LIST_ERROR,
  GET_USER_APPOINTMENTS_LIST_RESET,
  GET_USER_APPOINTMENT_DETAILS,
  GET_USER_APPOINTMENT_DETAILS_SUCCESS,
  GET_USER_APPOINTMENT_DETAILS_ERROR,
  GET_USER_APPOINTMENT_DETAILS_RESET,
  GET_DOCTOR_APPOINTMENT_LIST,
  GET_DOCTOR_APPOINTMENT_LIST_SUCCESS,
  GET_DOCTOR_APPOINTMENT_LIST_ERROR,
  GET_DOCTOR_APPOINTMENT_LIST_RESET,
  GET_DOCTOR_APPOINTMENT_OVERVIEW,
  GET_DOCTOR_APPOINTMENT_OVERVIEW_SUCCESS,
  GET_DOCTOR_APPOINTMENT_OVERVIEW_ERROR,
  GET_DOCTOR_APPOINTMENT_OVERVIEW_RESET,
} = require('./constants')

const userAppointmentsList = ( userId, type ) => createAction(GET_USER_APPOINTMENTS_LIST, { userId, type })

const userAppointmentsListSuccess = payload => createAction(GET_USER_APPOINTMENTS_LIST_SUCCESS, { payload })

const userAppointmentsListError = error => createAction(GET_USER_APPOINTMENTS_LIST_ERROR, { error })

const userAppointmentsListReset = () => createAction(GET_USER_APPOINTMENTS_LIST_RESET)

const getuserAppointmentDetails = id => createAction(GET_USER_APPOINTMENT_DETAILS, { id })

const getuserAppointmentDetailsSuccess = data => createAction(GET_USER_APPOINTMENT_DETAILS_SUCCESS, { data })

const getuserAppointmentDetailsError = error => createAction(GET_USER_APPOINTMENT_DETAILS_ERROR, { error })

const getuserAppointmentDetailsReset = () => createAction(GET_USER_APPOINTMENT_DETAILS_RESET)

const getDoctorAppointmentList = ( {doctorId, type, from, to} ) => createAction(GET_DOCTOR_APPOINTMENT_LIST, { doctorId, type, from, to })

const getDoctorAppointmentListSuccess = data => createAction(GET_DOCTOR_APPOINTMENT_LIST_SUCCESS, { data })

const getDoctorAppointmentListError = error => createAction(GET_DOCTOR_APPOINTMENT_LIST_ERROR, { error })

const getDoctorAppointmentListReset = () => createAction(GET_DOCTOR_APPOINTMENT_LIST_RESET)

const getDoctorAppointmentOverview = ( {apptID, doctorId} ) => createAction(GET_DOCTOR_APPOINTMENT_OVERVIEW, { apptID, doctorId })

const getDoctorAppointmentOverviewSuccess = data => createAction(GET_DOCTOR_APPOINTMENT_OVERVIEW_SUCCESS, { data })

const getDoctorAppointmentOverviewError = error => createAction(GET_DOCTOR_APPOINTMENT_OVERVIEW_ERROR, { error })

const getDoctorAppointmentOverviewReset = () => createAction(GET_DOCTOR_APPOINTMENT_OVERVIEW_RESET)

module.exports = {
  userAppointmentsList,
  userAppointmentsListSuccess,
  userAppointmentsListError,
  userAppointmentsListReset,
  getuserAppointmentDetails,
  getuserAppointmentDetailsSuccess,
  getuserAppointmentDetailsError,
  getuserAppointmentDetailsReset,
  getDoctorAppointmentList,
  getDoctorAppointmentListSuccess,
  getDoctorAppointmentListError,
  getDoctorAppointmentListReset,
  getDoctorAppointmentOverview,
  getDoctorAppointmentOverviewSuccess,
  getDoctorAppointmentOverviewError,
  getDoctorAppointmentOverviewReset,
}
